import * as React from 'react'
import { convertString } from 'DVWebNodeUtils'
require('../base.module.scss')

import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'

import * as st from './Text.module.scss'

interface TextProps extends BaseComponentProps {
  string?: any
  tag?: string
}

export class Text extends React.Component<TextProps> {
  constructor(props: TextProps) {
    super(props)
  }

  // Add displayName to preserve the component name on snapshot testing
  displayName = 'Text'

  render() {
    const dangerousInnerHTML = convertString(
      this.props.children ? this.props.children : this.props.string
    )
    if (!dangerousInnerHTML) return null
    return (
      React.createElement(this.props.tag || 'span', {
        className: extractClassNamesFromProps(
          this.props,
          st.text,
          // 'dvui-text'
        ),
        dangerouslySetInnerHTML: { __html: dangerousInnerHTML }
      })
    )
  }
}
